import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { BaseHeaderProps } from './BaseHeader.types';

export function BaseHeader({
  title,
  icon: Icon,
  actions,
  onBack,
  className = '',
}: BaseHeaderProps) {
  const baseClasses = 'px-2 md:px-3 py-2 md:py-2.5 border-b border-navy-700 bg-navy-800 flex items-center gap-1.5 md:gap-2';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  return (
    <header className={combinedClasses}>
      {onBack && (
        <button
          onClick={onBack}
          className="p-1.5 md:p-1 hover:bg-navy-700 active:bg-navy-600 rounded transition-colors flex-shrink-0 touch-manipulation"
          aria-label="Voltar"
        >
          <ArrowLeft className="w-4 h-4 md:w-4 md:h-4 text-gray-300" />
        </button>
      )}
      {Icon && <Icon className="w-4 h-4 md:w-4 md:h-4 text-yellow-400 flex-shrink-0" />}
      <h1 className="text-sm md:text-base font-medium text-white flex-1 min-w-0 truncate">{title}</h1>
      {actions && <div className="ml-auto flex items-center gap-1 md:gap-2 flex-shrink-0">{actions}</div>}
    </header>
  );
}

